import React from 'react';

import { ReactComponent as GuestUser } from '../../../assets/icons/guest-user-icon.svg';
import { ReactComponent as PhoneIcon } from '../../../assets/icons/phone-icon.svg';
import { brandIcons } from '../../../config/branding';
import { freeScheduleLimitTypes } from '../../../config/enum';
import { useAppSelector } from '../../../redux/hooks';
/**
 * filter
 * @returns
 */
function GuestChargingViewModal({ rowId }: { rowId?: string | null }) {
  const { guestCharging } = useAppSelector((state) => state.guestCharging);
  const guestChargingData = guestCharging.find((charging) => charging._id === rowId);
  return (
    <div className="guest-charging-view">
      <div className="view-page-header">
        <div className="header-left">
          <div className="header-icon">
            <div className="icon">
              <GuestUser />
            </div>
          </div>
          <div className="guest-details">
            <div className="details-name">{guestChargingData?.name}</div>
            {/* <div className="details-name">G98765</div> */}
            <div className="details-number">
              <span>
                <PhoneIcon />
              </span>
              <span> {guestChargingData?.phoneNumber}</span>
            </div>
          </div>
        </div>
        <div className="header-right" />
      </div>
      <hr />
      <div className="view-page-body">
        <div className="station-list">
          {guestChargingData?.chargingStationData?.map((chargingStation) => (
            <div className="station-item">
              <div className="station-name-icon">
                <div className="icon">
                  <brandIcons.facilityIcon />
                </div>
              <div className="station-name">{chargingStation.name}</div>
              </div>
              <div className="station-status">
                {chargingStation.isAvailable ? (
                  <div className="tag-success-label">Available</div>
                ) : (
                  <div className="tag-error-label">Unavailable</div>
                )}
              </div>
            </div>
          ))}
        </div>
        <hr />
        <div className="date-details">
          <div className="date-title">
            <div className="icon">
              <brandIcons.facilityIcon />
            </div>
            <div className="title">Date</div>
          </div>
          <div className="date-details-grid">
            <div className="grid">
              <div className="title">Range</div>
              <div className="date-value">
                <div className="value">
                  {guestChargingData?.fromDate} - {guestChargingData?.toDate}
                </div>
              </div>
            </div>
            <div className="grid">
              <div className="title">During</div>
              <div className="date-value">
                <div className="value">
                  {guestChargingData?.duration} /{' '}
                  {freeScheduleLimitTypes.find(
                    (limit) => limit.value === guestChargingData?.limitType,
                  )?.label || ''}
                </div>
              </div>
            </div>
            <div className="grid grid-4">
              <div className="title">Particular Date</div>
              <div className="date-value">
                {guestChargingData?.onSelectiveDates?.map((selectiveDate) => (
                  <div className="value">{selectiveDate}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="date-details">
          <div className="date-title">
            <div className="icon">
              <brandIcons.facilityIcon />
            </div>
            <div className="title">Time</div>
          </div>
          <div className="date-details-grid">
            <div className="grid grid-4">
              <div className="title">Range</div>
              <div className="date-value">
                {guestChargingData?.time?.map((eachSlot) => (
                  <div className="value">{eachSlot}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

GuestChargingViewModal.defaultProps = {
  rowId: '',
};

export default GuestChargingViewModal;
